document.addEventListener("DOMContentLoaded", async function () {
  const buttons = document.querySelectorAll(".quiz-cta-button");

  if (!buttons.length) return;

  const primaryUrl =
    "https://app.alyvewellness.com/api/proxy_get_latest_questionnaire?isActive=true";
  const fallbackUrl =
    "https://app.alyvewellness.com/api/proxy_get_latest_questionnaire";

  const payload = {
    tokenId: btoa(`gid://shopify/Customer/${window.customer_id}`),
    limit: 1,
  };

  const headers = {
    "Content-Type": "application/json",
    "x-customer-email": window.customer_email,
    "x-customer-id": window.customer_id,
    "x-customer-signature": window.token_hmac,
    "x-shopify-shop-domain": "alyve-store.myshopify.com",
  };


  // Every lookup must store the same shape. The backbone returns the result id as
  // `id`, while the quiz app and load-results.js both read `backboneId`.
  function formatQuestionnaire(record) {
    if (!record) return null;
    return {
      backboneId: record.backboneId || record.id || null,
      brandId: record.results?.brandId || null,
      completed: record.completed || false,
      email: record.results?.email || "",
      first_name: record.results?.first_name || "",
      has_previous_results: record.has_previous_results || null,
      isActive: record.isActive || null,
      previous_results_id: record.previous_results_id || null,
      questions: record.results?.questions || [],
      results: record.results || {},
      shopify_id: record.shopify_id || null,
      step: record.results?.questions?.length || 0,
    };
  }

  async function fetchQuestionnaire(primaryUrl, fallbackUrl, payload, headers) {
    try {
      const response = await fetch(primaryUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      if (!response.ok)
        throw new Error(`Primary HTTP error! Status: ${response.status}`);

      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        return formatQuestionnaire(data[0]);
      }


      console.warn(
        "⚠️ Primary API returned empty in Quiz Button, trying fallback..."
      );
    } catch (error) {
      console.error("Error with primary API (Quiz Button):", error.message);
    }

    try {
      const fallbackResponse = await fetch(fallbackUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(payload),
      });

      if (!fallbackResponse.ok)
        throw new Error(
          `Fallback HTTP error! Status: ${fallbackResponse.status}`
        );

      const fallbackData = await fallbackResponse.json();
      if (Array.isArray(fallbackData) && fallbackData.length > 0) {
        return formatQuestionnaire(fallbackData[0]);
      } else {
        console.warn("⚠️ Fallback API also returned empty in Quiz Button.");
      }
    } catch (fallbackError) {
      console.error(
        "Error with fallback API (Quiz Button):",
        fallbackError.message
      );
    }

    return null;
  }
  const grabLatestQuestionnaire = async (completedQuiz = false) => {
    const availableQuestionnaires =
      localStorage.getItem("alyve.current_consultation") || null;

    if (
      availableQuestionnaires &&
      JSON.parse(availableQuestionnaires)?.completed &&
      completedQuiz
    ) {
      return [JSON.parse(availableQuestionnaires)] || null;
    } else {
      return null;
    }
  };

  // Detect guest→logged-in transition
  const guestId = localStorage.getItem("alyve-guest-id") || null;
  const isGuestToCustomer = guestId && String(guestId).includes("guest") && window.customer_email;

  if (isGuestToCustomer) {
    localStorage.removeItem("alyve.current_consultation");
    localStorage.removeItem("alyve-guest-id");
    localStorage.removeItem("alyve-data-signature");
    localStorage.setItem("alyve_customer_data", JSON.stringify({
      email: window.customer_email,
      firstName: window.customer_first_name || "",
      id: window.customer_id,
      isGuest: false,
      signature: window.token_hmac || "",
    }));
  }

  const isLoggedIn = !!window.customer_id && !String(window.customer_id).includes("guest");

  try {
    let data = await grabLatestQuestionnaire(true);
    const currentPath = window.location.pathname;
    


    // Only hit the API if logged in AND localStorage was empty
    if (!data && isLoggedIn) {
      const questionnaireData = await fetchQuestionnaire( primaryUrl, fallbackUrl, payload, headers);
      if(questionnaireData){
         localStorage.setItem("alyve.current_consultation", JSON.stringify(questionnaireData));
         data = [questionnaireData];
      }
    }

    // Email fallback only for logged-in users when ID-based lookups returned nothing
    if ((!data || !data[0]) && isLoggedIn && window.customer_email) {
      try {
        const emailFallbackUrl = "https://app.alyvewellness.com/api/proxy_get_questionnaire_by_email";
        const emailResponse = await fetch(emailFallbackUrl, {
          method: "POST",
          headers,
          body: JSON.stringify({
            email: window.customer_email,
            shopify_id: btoa(`gid://shopify/Customer/${window.customer_id}`),
          }),
        });

        if (emailResponse.ok) {
          const emailData = await emailResponse.json();
          if (Array.isArray(emailData) && emailData.length > 0) {
            const formatted = formatQuestionnaire(emailData[0]);
            localStorage.setItem("alyve.current_consultation", JSON.stringify(formatted));
            data = [formatted];
          }
        }
      } catch (error) {
        console.error("Email fallback failed:", error.message);
      }
    }

// Resume support: pick up an in-progress local quiz (guests included)
if (!data || !data[0]) {
  try {
    const localConsultation = JSON.parse(localStorage.getItem("alyve.current_consultation") || "null");
    if (localConsultation && !localConsultation.completed) data = [localConsultation];
  } catch (e) {}
}

    // A guest whose localStorage Safari has wiped can still have their quiz's
    // recovery token in the cart (theme.liquid renders the flag), and the results
    // page restores from it, so offer their results rather than a fresh quiz.
    // Anything in localStorage, completed or in progress, still wins.
    const cartHasResults =
      !isLoggedIn && (!data || !data[0]) && window.alyveCartHasQuizToken === true;

    buttons.forEach((button) => {


      const startText = button.getAttribute("data-start-text") || "Start Quiz";
      const resultText =
        button.getAttribute("data-result-text") || "Show Results";

      let buttonText = startText;
      let buttonLink = "/pages/quiz";

      const backbone_id =
        Array.isArray(data) && data.length > 0
          ? data[0].backboneId || data[0].id || data[0].quizId || null
          : null;
      
      if (
        Array.isArray(data) &&
        data.length > 0 &&
        backbone_id &&
        data[0].completed
      ) {
        buttonText = resultText;
        buttonLink = "/pages/quiz-results";
      }

  if (
    Array.isArray(data) &&
    data.length > 0 &&
    backbone_id &&
    !data[0].completed
  ) {
    buttonText = button.getAttribute("data-resume-text") || "Resume Quiz";
    buttonLink = "/pages/quiz";
  }

      if (cartHasResults) {
        buttonText = resultText;
        buttonLink = "/pages/quiz-results";
      }

      button.textContent = buttonText;

      if (button.tagName === "A") {
        button.setAttribute("href", buttonLink);
      }

      button.addEventListener("click", () => {
        if (window.location.pathname === "/pages/free-water-bottle-offer") {
          sessionStorage.setItem("campaign", "free_water_bottle");
        }
      });
    });
  } catch (error) {
    console.error("Error reading consultation data or API fallback:", error);

    buttons.forEach((button) => {
      button.textContent = "Start Quiz";
      if (button.tagName === "A") {
        button.setAttribute("href", "/pages/quiz");
      }
    });
  }
});
